"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatBot = void 0;
var _config = require("@ori-appshell/config");
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _script = _interopRequireDefault(require("next/script"));
var _getChatbotSettings = require("./getChatbotSettings");
var _jsxRuntime = require("react/jsx-runtime");
const ChatBot = ({
  data,
  environment,
  localizations
}) => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    botApiUrl,
    identityUrl,
    clientAppsUrl
  } = (0, _configurationManager.useServiceUrls)(['identity', 'clientApps']); // botAPI is not required intentionally - this API is not available for all tenants

  if (botApiUrl == null) {
    return null;
  }
  const settings = JSON.stringify((0, _getChatbotSettings.getChatbotSettings)({
    currentLanguage: language,
    customerId,
    data,
    environment,
    localizations,
    tenant,
    chatApiUrl: botApiUrl,
    identityApiUrl: identityUrl
  }));
  const entryFile = (0, _config.createSpaEntryfileUrl)('chat-bot', environment, clientAppsUrl);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      id: "chat-bot-root",
      "data-app-url": `${clientAppsUrl}/chat-bot/`,
      "data-bot-chat-option": settings,
      "data-tenant": tenant
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_script.default, {
      strategy: "afterInteractive",
      src: entryFile
    })]
  });
};
exports.ChatBot = ChatBot;
